import React, { Component, ReactNode } from 'react';
import { tokens } from '@fluentui/react-components';

interface CopilotErrorBoundaryProps {
  children: ReactNode;
  fallbackMessage?: string;
}

interface CopilotErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: any;
}

class CopilotErrorBoundary extends Component<CopilotErrorBoundaryProps, CopilotErrorBoundaryState> {
  constructor(props: CopilotErrorBoundaryProps) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error: Error): CopilotErrorBoundaryState {
    return { hasError: true, error, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('CopilotErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const fallbackMessage = this.props.fallbackMessage || 
        "Something went wrong. Please try again later.";
      
     
      
      return (
        <div>
          {fallbackMessage}
        </div>
      );
    }

    return this.props.children;
  }
}

export default CopilotErrorBoundary;